import React from 'react';
import  {useRef} from 'react';
import {Link} from "react-router-dom";
import imageOnError from '../helpers/imgOnError.js';
import {RtFAQItemForJSON} from '../../../server/routes/route-types.js'

interface DataSetTechnologyDataProps {
    technology: string;
    url: string;
}

interface DataSetCVEDataProps {
    cve: string;
    url: string;
}

interface DataSetCWEDataProps {
    cwe: string;
    url: string;
    title: string;
}

// interface FAQItem {
//     question: string;
//     answer: string;
//     skipFromJson?: boolean;
// }

interface FAQPageDataProps {
    faq: RtFAQItemForJSON[];
}

export function OrganizationData() {

	const orgData = 
	{
		"@context": "https://schema.org",
		"@type": "Organization",
		"url": "https://webtechsurvey.com/",
		"sameAs": [
			"https://www.linkedin.com/company/webtechsurvey/"
		],
		"logo": "https://webtechsurvey.com/s/img/logo600.png",
		"name": "WebTechsSurvey",
		"description": "WebTechSurvey offers extensive technographic data to facilitate lead generation and prospect identification.",
		"address": {
			"@type": "PostalAddress",
			"addressCountry": "US",
			"addressRegion": "CA"
		}
	};

	return (
		<script
			type="application/ld+json"
			dangerouslySetInnerHTML={{
			__html: JSON.stringify(orgData),
			}}
		/>

	)
}

// WebSite obwect implements searh functionality
export function WebSiteData() {

	const websiteData = 
	{
		"@context": "https://schema.org/",
		"@type": "WebSite",
		"name": "WebTechSurvey",
		"url": "https://webtechsurvey.com/",
		"potentialAction": {
			"@type": "SearchAction",
			"target": "https://webtechsurvey.com/search?search={search_term_string}",
			"query-input": "required name=search_term_string"
		}
	};

	return (
		<script
			type="application/ld+json"
			dangerouslySetInnerHTML={{
			__html: JSON.stringify(websiteData),
			}}
		/>

	)
}


export function DataSetTechnologyData(props: DataSetTechnologyDataProps) {
	let technology = props.technology;
	let url = props.url;
	let year = new Date().getFullYear();
	// "dateModified": "2024-03-07T13:44:56+05:30",
	// let dateModified = new Date()
	// "legalName": "Dataintelo Consulting Pvt. Ltd.",

	const orgData = 
	{
		"@context": "https://schema.org/",
		"@type": "Dataset",
		"name": `Websites using ${technology}`,
		"description": `A complete list of live websites using the ${technology} technology, compiled through global website indexing conducted by WebTechSurvey.`,
		"url": `https://webtechsurvey.com/technology/${url}`,
		"isAccessibleForFree": "false",
		"distribution": [
			{
				"@type": "DataDownload",
				"encodingFormat": "csv",
				"contentUrl": `https://webtechsurvey.com/technology/${url}`
			}
		],
		"creator": {
			"@type": "Organization",
			"url": "https://webtechsurvey.com",
			"name": "WebTechSurvey",
			"logo": {
				"@type": "ImageObject",
				"url": "https://webtechsurvey.com/s/img/logo600.png"
			},
			"contactPoint": {
				"@type": "ContactPoint",
				"contactType": "Sales Team",
				"email": "contact@webtechsurvey.com"
			}
		},
		"temporalCoverage": `${year}`,
		"spatialCoverage": "Global",
		"license": {
			"@type": "CreativeWork",
			"name": "WebTechSurvey Terms",
			"url": "https://webtechsurvey.com/terms"
		}
	};

	return (
		<script
			type="application/ld+json"
			dangerouslySetInnerHTML={{
			__html: JSON.stringify(orgData),
			}}
		/>

	)
}



export function DataSetCVEData(props: DataSetCVEDataProps) {
	let cve = props.cve;
	let url = props.url;
	let year = new Date().getFullYear();
	// "dateModified": "2024-03-07T13:44:56+05:30",
	// let dateModified = new Date()
	// "legalName": "Dataintelo Consulting Pvt. Ltd.",

	const orgData = 
	{
		"@context": "https://schema.org/",
		"@type": "Dataset",
		"name": `Websites susceptible to ${cve}`,
		"description": `A complete list of live websites affected by ${cve}, compiled through global website indexing conducted by WebTechSurvey.`,
		"url": `https://webtechsurvey.com/cve/${cve}`,
		"isAccessibleForFree": "false",
		"distribution": [
			{
				"@type": "DataDownload",
				"encodingFormat": "csv",
				"contentUrl": `https://webtechsurvey.com/cve/${url}`
			}
		],
		"creator": {
			"@type": "Organization",
			"url": "https://webtechsurvey.com",
			"name": "WebTechSurvey",
			"logo": {
				"@type": "ImageObject",
				"url": "https://webtechsurvey.com/s/img/logo600.png"
			},
			"contactPoint": {
				"@type": "ContactPoint",
				"contactType": "Sales Team",
				"email": "contact@webtechsurvey.com"
			}
		},
		"temporalCoverage": `${year}`,
		"spatialCoverage": "Global",
		"license": {
			"@type": "CreativeWork",
			"name": "WebTechSurvey Terms",
			"url": "https://webtechsurvey.com/terms"
		}
	};

	return (
		<script
			type="application/ld+json"
			dangerouslySetInnerHTML={{
			__html: JSON.stringify(orgData),
			}}
		/>

	)
}

export function DataSetCWEData(props: DataSetCWEDataProps) {
	let cwe = props.cwe;
	let url = props.url;
	let title = props.title;
	let year = new Date().getFullYear();
	// "dateModified": "2024-03-07T13:44:56+05:30",
	// let dateModified = new Date()
	// "legalName": "Dataintelo Consulting Pvt. Ltd.",

	const orgData = 
	{
		"@context": "https://schema.org/",
		"@type": "Dataset",
		"name": `Websites susceptible to ${cwe} - ${title}`,
		"description": `A complete list of live websites vulnerable to ${cwe}, compiled through global website indexing conducted by WebTechSurvey.`,
		"url": `https://webtechsurvey.com/cwe/${cwe}`,
		"isAccessibleForFree": "false",
		"distribution": [
			{
				"@type": "DataDownload",
				"encodingFormat": "csv",
				"contentUrl": `https://webtechsurvey.com/cwe/${url}`
			}
		],
		"creator": {
			"@type": "Organization",
			"url": "https://webtechsurvey.com",
			"name": "WebTechSurvey",
			"logo": {
				"@type": "ImageObject",
				"url": "https://webtechsurvey.com/s/img/logo600.png"
			},
			"contactPoint": {
				"@type": "ContactPoint",
				"contactType": "Sales Team",
				"email": "contact@webtechsurvey.com"
			}
		},
		"temporalCoverage": `${year}`,
		"spatialCoverage": "Global",
		"license": {
			"@type": "CreativeWork",
			"name": "WebTechSurvey Terms",
			"url": "https://webtechsurvey.com/terms"
		}
	};

	return (
		<script
			type="application/ld+json"
			dangerouslySetInnerHTML={{
			__html: JSON.stringify(orgData),
			}}
		/>

	)
}

interface FAQStructuredData {
	"@context": string;
	"@type": string;
	mainEntity: FAQSturedEntry[];
}

interface FAQSturedEntry {
	"@type": "Question",
	name: string,
	"acceptedAnswer": {
		"@type": "Answer",
		text: string
	}
}

export function FAQPageData({faq}: FAQPageDataProps) {

	/*let Question = {
		"@type": "Question",
		"name": "",
		"acceptedAnswer": {
		  "@type": "Answer",
		  "text": ""
		}
	};*/

	let faqData: FAQStructuredData = 
	{
		"@context": "https://schema.org",
		"@type": "FAQPage",
		mainEntity: []
	};

	faq.forEach((f) => {
		if (!f.skipFromJson) {
			let q: FAQSturedEntry = {
				"@type": "Question",
				"name": f.question,
				"acceptedAnswer": {
				  "@type": "Answer",
				  "text": f.answer
				}
			};
			faqData.mainEntity.push(q);	
		}
	})
	
	return (
		<script
			type="application/ld+json"
			dangerouslySetInnerHTML={{
			__html: JSON.stringify(faqData),
			}}
		/>

	)
}

